var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.84,22.57h0a.49.49,0,0,1-.49.49H22.83a.49.49,0,0,1-.49-.49.5.5,0,0,1,.14-.35l2.45-2.44-.1-.1A14.69,14.69,0,0,0,13.7,14.57l-.66,0h0a.49.49,0,0,1-.31-.87A9.43,9.43,0,0,1,19,11.31a9.59,9.59,0,0,1,3.35.61A18.26,18.26,0,0,1,28.72,16L31,13.68a.52.52,0,0,1,.35-.14.49.49,0,0,1,.49.49Zm0,0ZM29.47,27.9a.49.49,0,0,1-.18.38A9.43,9.43,0,0,1,23,30.69a9.59,9.59,0,0,1-3.35-.61,18.26,18.26,0,0,1-6.37-4L11,28.32a.52.52,0,0,1-.35.14.49.49,0,0,1-.49-.49V19.43h0a.49.49,0,0,1,.49-.49h8.52a.49.49,0,0,1,.49.49.5.5,0,0,1-.14.35l-2.45,2.44.1.1A14.69,14.69,0,0,0,28.3,27.43l.66,0h0A.49.49,0,0,1,29.47,27.9Zm-2.33.59a15.78,15.78,0,0,1-10.78-5.42L16.29,23l-.77-.78.77-.77L17.7,20H11.26v6.45l1.24-1.24.78-.77.77.76A17.12,17.12,0,0,0,20,29a8.32,8.32,0,0,0,7.11-.55Z",
    fill: "#624de3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.0107a57e7ec74246325218ff9a6ef252.svg";
export { ForwardRef as ReactComponent };